// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na.link[data-v-959f54fc] {\n  color: green;\n}\n.fullscreen[data-v-959f54fc] {\n  height: 100vh; /* set height to viewport height */\n}\n.shortage-entry[data-v-959f54fc] {\n  background-color: #fff8e1;\n  border-left: 3px solid #ff9800;\n  padding: 8px;\n  margin: 4px 0;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
